import Head from 'next/head'
import styles from '../../styles/index.module.css'
import Script from 'next/script'

export default function Home() {

  return (
    <>
      <Head>
        <title>Terms On Consumer Client Payment for Service | StringsSG</title>
        <meta charSet="utf-8"/>
        <meta httpEquiv="X-UA-Compatible" content="IE=edge"/>
        <meta name="viewport" content="width=device-width, initial-scale=1, minimum-scale=1.0, maximum-scale=1.0, user-scalable=no"/>
        <meta name="description" content="You are a consumer client for StringsSG, if you have registered an account with us and have availed any professional service like handyman service, air conditioner servicing, personal training, domestic helper etc."/>
        <meta name="keywords" content="We help you in HDB or Condo rental and purchase, health Investment and Insurance plan, food catering,
	         domestic helper, handyman services, aircon servicing, beauty and massage, interior designing, fitness trainer, 
	         wedding, birthday and other event planning"/>
        <meta name="author" content="StringsSG"/>
        <meta name="google-site-verification" content="JAjj5vAc8Xxrh4idRAchZhYR6rwxWPAk3vxMdx-dwVQ" />
        <meta property="og:url"   content="https://www.stringssg.com/terms/consumer-clients-payment-for-service" />
        <meta property="og:type"   content="website" />
        <meta property="og:title"    content={`Terms On Consumer Client Payment for Service | StringsSG`}/>
        <meta property="og:description" content="You are a consumer client for StringsSG, if you have registered an account with us and have availed any professional service like handyman service, air conditioner servicing, personal training, domestic helper etc." />
        <meta property="og:image"  content="https://stringssg-assets.s3-ap-southeast-1.amazonaws.com/static/Google-icon.png" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:image" content="https://stringssg-assets.s3-ap-southeast-1.amazonaws.com/static/Google-icon.png" />
        <meta name="twitter:site" content="@stringssg"/> 
        <meta name="twitter:url" content="https://www.stringssg.com/terms/consumer-clients-payment-for-service"/>
        <meta name="twitter:title" content={`Terms On Consumer Client Payment for Service | StringsSG`}/> 
        <meta name="twitter:description" content="You are a consumer client for StringsSG, if you have registered an account with us and have availed any professional service like handyman service, air conditioner servicing, personal training, domestic helper etc."/>
        <link rel="icon" href="/favicon.ico" />
        <link rel="canonical" href="https://www.stringssg.com/terms/consumer-clients-payment-for-service"/>
        </Head>
            <div className="max-w-4xl mx-auto py-4"> 
                <div id="payment-from-client" className='text-gray-500 p-4 space-y-6 py-8 leading-7 text-sm'>
                    <h1 className='text-xl uppercase'>Terms On Consumer Client Payment for Service</h1>
                    <div className='space-y-2'>
                        <div className='font-bold'>Who is a consumer client?</div>
                        <div>
                            You are a consumer client for StringsSG, if you have registered an account with us and have availed any professional service like handyman service, 
                            air conditioner servicing, personal training, domestic helper etc.
                        </div>
                        <p>
                            These terms are applicable if you have opened a request for service on the StringsSG platform and have an invoice from StringsSG Pte Ltd due for payment.
                        </p>
                    </div>
                    <p>
                        Please find below the terms and conditions for payment within 48 hours of services rendered, with an applicable daily compounded interest rate of 3% for late payments:
                    </p>
                    <div className='space-y-2'>
                        <h2 className='font-bold'>1. Payment Terms:</h2>
                        <p>
                            The client shall make payment for services rendered within 48 hours of receipt of the invoice.
                        </p>
                    </div>
                    <div className='space-y-2'>
                        <h2 className='font-bold'>2. No Show Fee Policy:</h2>
                        <p>
                            A no-show fee of the full paid amount (for prepaid services) or $40 will apply in the following scenarios:
                        </p>
                        <ul className='pl-4 list-disc space-y-2'>
                            <li><strong>Home Services: </strong>When a client has booked a service to be performed at their home, and upon the arrival of the service team, the client is either not present at the confirmed service address or has declined to receive the service.</li>
                            <li><strong>Offsite Location Service: </strong>When a client has booked a service at an offsite location and does not show up for the service at the confirmed time slot.</li>
                        </ul>
                    </div>
                    <div className='space-y-2'>
                        <h2 className='font-bold'>3. Interest on Late Payment:</h2>
                        <p>
                            If the client fails to make payment within the aforementioned 48-hour period, a daily compounded interest rate of 3% will be applicable until the outstanding amount is paid in full.
                        </p>
                    </div>
                    <div className='space-y-2'>
                        <h2 className='font-bold'>4. Payment Mode:</h2>
                        <p>
                            Payment shall be made via the StringsSG platform via the available modes of payment. If you cannot make the payment with the available modes of payment, please cancel
                            your request for service or contact us within 24 hours from the time of service request open.
                        </p>
                    </div>
                    <div className='space-y-2'>
                        <h2 className='font-bold'>5. Disputed Invoices:</h2>
                        <p>
                            If the client disputes an invoice, they shall notify the service provider within 24 hours of receiving the invoice. If the dispute cannot be resolved, 
                            the matter shall be referred to an arbitrator appointed by both parties.
                        </p>
                    </div>
                    <div className='space-y-2'>
                        <h2 className='font-bold'>6. Payment Default:</h2>
                        <p>
                            If the client defaults on payment, then StringsSG and/or the service provider reserves the right to take legal action to recover the outstanding amount, 
                            including but not limited to engaging debt collection agencies.
                        </p>
                    </div>
                    <div className='space-y-2'>
                        <h2 className='font-bold'>8. Termination of Services:</h2>
                        <p>
                            StringsSG reserves the right to terminate services in the event of payment default by the client.
                        </p>
                    </div>
                    <p>
                        By agreeing to these terms and conditions, the client acknowledges their responsibility to make timely payment for services rendered, and understands the 
                        consequences of defaulting on payment.
                    </p>
                </div>
            </div>
        <Script 
          id="google-tagmanager-new"
          src="https://www.googletagmanager.com/gtag/js?id=G-QD1HGGHDYJ"
          strategy="lazyOnload"
          onLoad={() => {              
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
          
            gtag('config', 'G-QD1HGGHDYJ');
          }} 
        />
        <Script id="facebook-tracking" strategy="lazyOnload">
          {`!function(f,b,e,v,n,t,s)
					  {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
					  n.callMethod.apply(n,arguments):n.queue.push(arguments)};
					  if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
					  n.queue=[];t=b.createElement(e);t.async=!0;
					  t.src=v;s=b.getElementsByTagName(e)[0];
					  s.parentNode.insertBefore(t,s)}(window, document,'script',
					  'https://connect.facebook.net/en_US/fbevents.js');
					  fbq('init', '128634041116395');
					  fbq('track', 'PageView');`}
        </Script>
    </>
  )
}
